export default __webpack_public_path__ + "static/media/cart.b39d82a3.gif";